import { useSelector } from "react-redux";
import FormAndFooterView from "./FormAndFooterView";
import IntroView from "./IntroView";
import LogoView from "./LogoView";
import Notification from "./Notification";
import ProjectInfoView from "./ProjectInfoView";
import ProjectsView from "./ProjectsView";
import SkillsView from "./SkillsView";
import "./portrait-xs-layout.css";
import { useEffect, useState } from "react";

function PortraitXSLayout() {
  const { activeProject, projectData } = useSelector((store) => store.app);
  const [currentViewIndex, setCurrentViewIndex] = useState(0);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const viewCount = 5;

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe && currentViewIndex !== viewCount - 1) {
      setCurrentViewIndex((currentViewIndex + 1 + viewCount) % viewCount);
    } else if (isRightSwipe && currentViewIndex > 0) {
      setCurrentViewIndex((currentViewIndex - 1 + viewCount) % viewCount);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setCurrentViewIndex(1);
    }, 1000);
  }, []);

  return (
    <div className="w-full h-full">
      <div
        className="w-full h-full overflow-hidden relative"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <Notification />
        {Number.isInteger(activeProject) ? (
          <ProjectInfoView
            title={projectData[activeProject].title}
            desc={projectData[activeProject].desc}
          />
        ) : (
          <div
            style={{ transform: `translate(-${currentViewIndex * 100}vw, 0)` }}
            className="w-max h-full overflow-hidden flex flex-row transition-transform duration-500"
          >
            <LogoView />
            <IntroView active={currentViewIndex === 1} />
            <SkillsView active={currentViewIndex === 2} />
            <ProjectsView active={currentViewIndex === 3} />
            <FormAndFooterView />
          </div>
        )}
      </div>
    </div>
  );
}

export default PortraitXSLayout;
